import { jsx as _jsx } from "react/jsx-runtime";
import { CardActionButton } from "@bluframe/mightychroma-mightytool-ui";
const Gather = ({ isLoading, onGather }) => (_jsx(CardActionButton, { label: "Gather", loading: isLoading, onClick: onGather }));
export default Gather;
